import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fixedValues, searchFieldsList, templateCode } from 'src/environments/mapping-fields';

@Injectable({
  providedIn: 'root'
})
export class CadastroHelprevService {

  constructor(private http: HttpClient) { }

  headerTemplate = {
    'Content-Type': 'application/json'
  };

  validateSession(): Observable<any> {
    return this.http.get<any>(`/relseg/validate`);
  }

  sendRequest(data: any): Observable<any> {
    return this.http.post<any>(`/api/v1/sr/?type=1&template=${templateCode}`, data, { headers: this.headerTemplate, withCredentials: true });
  }

  find(id:string){
    let assignedGroup = fixedValues.filter((item:any) => item.key=="assigned_group")[0].value;
    return this.http.get<any>(`/api/v1/sr/?fields=${searchFieldsList}&assigned_group=${assignedGroup}&ids=${id}`);
  }
}
